import React from 'react';
import PropTypes, { customPagePropType } from '../../helpers/propTypes';
import FailedIcon from './icons/Fail';
import PassedIcon from './icons/Pass';
import MessagePage from './MessagePage';

function EligibilityPage({
  title,
  text,
  buttonText,
  onButtonClick,
  isEligible,
  showButton,
  subText,
  noIcon,
  customPage,
}) {
  let icon = null;
  if (!noIcon) {
    icon = isEligible ? <PassedIcon /> : <FailedIcon />;
  }

  return (
    <MessagePage
      buttonText={buttonText}
      customPage={customPage}
      icon={icon}
      onButtonClick={onButtonClick}
      showButton={showButton}
      subText={subText}
      text={text}
      title={title}
    />
  );
}

EligibilityPage.propTypes = {
  buttonText: PropTypes.node,
  customPage: customPagePropType,
  isEligible: PropTypes.bool,
  noIcon: PropTypes.bool,
  onButtonClick: PropTypes.func,
  showButton: PropTypes.bool,
  subText: PropTypes.node,
  text: PropTypes.node,
  title: PropTypes.node,
};

EligibilityPage.defaultProps = {
  buttonText: undefined,
  customPage: {},
  isEligible: false,
  noIcon: false,
  onButtonClick: undefined,
  showButton: false,
  subText: undefined,
  text: undefined,
  title: undefined,
};

export default EligibilityPage;
